import { render, staticRenderFns } from "./MagHistory.vue?vue&type=template&id=1e45976c"
import script from "./MagHistory.vue?vue&type=script&lang=js"
export * from "./MagHistory.vue?vue&type=script&lang=js"
import style0 from "./MagHistory.vue?vue&type=style&index=0&id=1e45976c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports